import { SelectionProviderChildProps, VerticalFlexContainer } from '@tableau/data-catalog-shared';
import * as React from 'react';
import { TableQuery_tables } from '../../../gen-src/queries/TableQuery';
import { PaneWithTitle } from '../placePage/PaneWithTitle';
import { ColumnsGridSortProvider } from '../sorting/sortProviders/ColumnsGridSortProvider';
import { TableColumnsQueryGrid } from './TableColumnsQueryGrid';
import { TableDetails } from './TableDetails';

export interface TableColumnsPaneProps extends SelectionProviderChildProps {
  readonly title: string;
  readonly table: TableQuery_tables;
  readonly tableId: string;
  readonly rowCount: number | null;
  readonly hackyUpdateNumber: number;
}
export function TableColumnsPane(props: TableColumnsPaneProps): JSX.Element {
  return (
    <VerticalFlexContainer fillFlexParent={true}>
      <TableDetails table={props.table} />
      <PaneWithTitle title={props.title}>
        <ColumnsGridSortProvider>
          {({ orderBy, updateSortOrder }) =>
            <TableColumnsQueryGrid
              tableId={props.tableId}
              orderBy={orderBy}
              selectedKeys={props.selectedKeys}
              updateSelectionForKey={props.updateSelectionForKey}
              updateSortOrder={updateSortOrder}
              rowCount={props.rowCount}
              hackyUpdateNumber={props.hackyUpdateNumber}
            />
          }
        </ColumnsGridSortProvider>
      </PaneWithTitle>
    </VerticalFlexContainer>
  );
}
